window.fetch = window.fetch.bind(window) // Hack for firebase error on login
export default 1
